module.exports = __webpack_public_path__ + "static/media/elbowStrength1.55f43efe.png";